import { Helmet } from "react-helmet";
import {
  Box,
  Button,
  Container,
  Grid,
  Typography,
  usePagination,
  Radio,
  MenuItem,
  FormControl,
  Select,
  OutlinedInput,
  Divider,
  TextareaAutosize,
  TextField,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@mui/styles";
import { Link as RouterLink, useNavigate, useLocation } from 'react-router-dom'
import React, { useEffect } from "react";
import { styled } from "@mui/material/styles";
import cssVariables from "../../../../theme/cssVariables";
import { ReactComponent as SuccessIcon } from "../../../../icons/success-icon.svg";
import FeedbackRating from "../../../../constants/Feedback";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

const CreateCorporateGoalSuccess = (props) => {
  const { t } = useTranslation();
  const _ = require("lodash");
  const { state, history } = useLocation();
  const [comment, setComment] = React.useState("");
  const [rating, setRating] = React.useState("");

  useEffect(() => {
    if (!state?.validCreate) {
      goto("/manage-corporate-goal")
    } else {
      state.validCreate = undefined
    }
  }, [])
  const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: "#343A40",
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#343A40",
      color: "#FFFFFF",
      padding: "11px 15px",
    },
  }));
  const language = localStorage.getItem("lang");
  // ----------------------------------
  const useStyles = makeStyles({
    root: {
      fontSize: "16px",
    },
    plusSvg: {
      "& > path": {
        fill: "#fff",
        stroke: "#fff",
      }
    },
    statusGraph: {
      "& > path": {
        fill: "#fff"
      }
    },
    internalIcon: {
      "& > path": {
        fill: "#fff"
      },
      '& g > path': {
        fill: '#fff'
      },
    },
    linkIcon: {
      "& > path": {
        fill: "#A0A0A0"
      },
      '& g > path': {
        fill: '#A0A0A0'
      },
    },
    paginationRoot: {
      color: `${cssVariables.color.primary}`,
      backgroundColor: "white!important",
      minWidth: "30px!important",
      padding: "5px!important",
    },
    paginationSelected: {
      color: "white!important",
      border: "1px solid rgba(93, 161, 150, 0.5)!important",
      backgroundColor: `${cssVariables.color.primary}!important`,
      minWidth: "30px!important",
      padding: "5px!important",
    },
    clickable: {
      cursor: "pointer",
      transition: "color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
      '&:hover': {
        color: 'rgb(65, 112, 105) !important'
      }
    },
    fillDisable: {
      '& > path': {
        fill: '#A0A0A0'
      },
      '& g > path': {
        fill: '#A0A0A0'
      },
    },
    btn: {
      '& > svg': {
        marginLeft: "10px"
      },
    },
    boxIcon: {
      backgroundColor: "#ffffff",
      borderRadius: "50%",
      width: "40px",
      height: "40px",
      "box-shadow": "0px 4px 4px rgba(0, 0, 0, 0.15)",
      border: "none",
      transition: "0.5s",
      cursor: "pointer",
      margin: "0 20px",
      "&:hover": {
        transition: "0.5s",
        animation: `$shadow 1.2s infinite`,
        transform: "scale(1.2)",
      },
    },
  });
  const classes = useStyles();
  const styles = {
    link: {
      color: "#5DA196",
      cursor: "pointer",
    },
    end: {
      color: "#A3A3A3",
    },
  };

  const navigate = useNavigate();
  const goto = (data) => {
    navigate("/admin" + data, { replace: false });
  }


  return (
    <>
      <Helmet>
        <title>Create Corporate Goal Success | KPI </title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100%",
          py: 3,
        }}
      >
        <Container maxWidth="xl">
          <Grid container pt={2} pb={2}>
            <Typography fontSize={16} lineHeight={1} color="#68717A">
              <span style={styles.link} onClick={() => navigate("/kpi/home")}>
                {t('label.home')}
              </span> /
              <span style={styles.link} onClick={() => goto('/manage-corporate-goal')}>
                {` ${t('corporateGoal.label.title')}`}
              </span> /
              <span style={styles.end} >
                {` ${t('corporateGoal.label.create')}`}
              </span>
            </Typography>
          </Grid>
          {/* start portfoliio 10*/}
          {/* <Grid container item> */}
          <Grid container textAlign="center" justifyContent='center' style={{ height: `calc(${window.innerHeight}px - 160px)`, minHeight: "600px", alignItems: 'center', backgroundColor: '#fff' }}>
            <Box style={{ paddingLeft: '20px', paddingRight: '20px', paddingTop: 40, paddingBottom: 40 }}>
              <Grid item md={12}>
                <SuccessIcon />
              </Grid>
              <Grid item md={12} >
                <Typography variant="h1" fontSize={36} lineHeight="39.6px" fontWeight="500">
                  {t("corporateGoal.label.successCreateTitle")}
                </Typography>
              </Grid>
              <Grid item md={12} pr={1} mt={1} mb={3}>
                <Typography fontSize={16}>
                  {t("corporateGoal.label.successCreate")}
                </Typography>
              </Grid>
              <Grid lg={12} xs={12} item textAlign="center">
                <Button
                  size="small"
                  aria-controls="simple-menu"
                  aria-haspopup="true"
                  onClick={() => { goto('/manage-corporate-goal') }}
                  color="primary"
                  variant="contained"
                  style={{ paddingLeft: 30, paddingRight: 30, textTransform: 'none' }}
                >
                  <Typography>{t("corporateGoal.label.returnToMain")}</Typography>
                </Button>
              </Grid>
              <Divider style={{ marginTop: 20, marginBottom: 20 }} />
              <Box sx={{ backgroundColor: "#F5F5F5", width: "100%", "box-shadow": "inset 0px 4px 5px rgba(0, 0, 0, 0.05)" }}>
                <Box sx={{ display: "flex", flexFlow: "column", justifyContent: "center", alignItems: "center", paddingTop: "25px", width: "100%" }}>
                  <Typography fontSize={18} lineHeight="26.91px" fontWeight={500} >{t('evaluation.experienceWithIPOP')} </Typography>
                  <Typography fontSize={14} lineHeight="20.93px" fontWeight={400} pt="5px" sx={{ color: "#939393" }} >{t('evaluation.feedback')}</Typography>
                  <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "20px 0px" }}>

                    {FeedbackRating.map((rating, i) => (
                      <BootstrapTooltip title={rating.label} placement="top" key={i}>
                        <Box className={`${classes.boxIcon}`}>
                          <img src={rating.icon} alt={rating.label} onClick={() => setRating(rating.id)}></img>
                        </Box>
                      </BootstrapTooltip>
                    ))}
                  </Box>
                  <Box sx={{ maxWidth: "500px", width: "100%" }}>
                    <TextField
                      fullWidth
                      name="comment"
                      placeholder={t('evaluation.pleaseLeaveYourComment')}
                      onChange={(e) => setComment(e.target.value)}
                      value={comment}
                      variant="outlined"
                      multiline
                      rows={2}
                    />
                  </Box>
                  <Typography fontSize={10} lineHeight="14.95px" fontWeight={400} variant="sub_label" pt="10px" pb="15px">{t('evaluation.characterDesignBy')} <span style={{ color: "#939393", fontWeight: "500" }}>SODA</span></Typography>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Container>
      </Box>
    </>
  );
};
export default CreateCorporateGoalSuccess;
